import ImportListPage from '@/pages/catalog/ImportListPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/catalog/import/')({
  component: ImportListPage,
})
